import React, { useState, useEffect, useMemo, useContext, createContext } from 'react'
import { JourneyContext } from './journeyContext'
import { getConfigurationsByType } from "../../services/apiservice"

export const PaymentConfigContext = createContext()

export const PaymentConfigContextProvider = (props) => {
    const [rawConfig, setRawConfig] = useState(null)
    const [journeyState] = useContext(JourneyContext);

    // fetched exactly once per journey mount 
    useEffect(() => {
        (async () => {
            try {
                const resp = await getConfigurationsByType({ type: "payment-config" })
                setRawConfig(resp?.data?.[0]?.config || null);
            } catch (error) {
                console.info(error);
            }
        })();
    }, [])

    // channel/journeyIdFromStrapi are only resolved asynchronously by other
    // effects elsewhere in the journey, so the config is derived reactively
    // rather than computed once at fetch time
    const PaymentConfigData = useMemo(() => {
        const config = {
            glomoPay: false,
            swiftPay: false
        }
        if (!rawConfig || !journeyState.journeyIdFromStrapi || !journeyState.channel) {
            return config;
        }
        const Product = rawConfig?.products?.[journeyState.journeyIdFromStrapi] || null;
        config.glomoPay = Product?.glomoPayChannels?.includes(journeyState.channel?.toUpperCase()) || false;
        config.swiftPay = Product?.swiftPayChannels?.includes(journeyState.channel?.toUpperCase()) || false;
        return config;
    }, [rawConfig, journeyState.journeyIdFromStrapi, journeyState.channel])

    return (
        <PaymentConfigContext.Provider value={[PaymentConfigData]}>
            {props.children}
        </PaymentConfigContext.Provider>
    )
}